import { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/components';

interface AppPanelContainerProps extends React.PropsWithChildren<BoxProps> {
  size: 'wide' | 'medium' | 'narrow';
  isCollapsed: boolean;
  isVisible?: boolean;
}

export const getPanelWidth = (size: AppPanelContainerProps['size']) => {
  switch (size) {
    case 'wide':
      return '610px';
    case 'medium':
      return '440px';
    case 'narrow':
      return '360px';
    default:
      return '360px';
  }
};

export const AppPanelContainer = ({
  isCollapsed,
  isVisible = true,
  size,
  children,
  ...boxProps
}: AppPanelContainerProps) => {
  const { width, marginRight } = useMemo(() => {
    return {
      width: getPanelWidth(size),
      marginRight: isCollapsed ? `calc(-1 * ${getPanelWidth(size)})` : '0',
    };
  }, [isCollapsed, size]);

  return (
    <Box
      width={width}
      maxWidth={width}
      marginRight={marginRight}
      overflow={isVisible ? 'auto' : 'hidden'}
      position="relative"
      transition="all 0.3s ease"
      opacity={isVisible ? 1 : 0}
      visibility={isVisible ? 'visible' : 'hidden'}
      pointerEvents={isVisible ? 'auto' : 'none'}
      isolation="isolate"
      {...boxProps}
    >
      {children}
    </Box>
  );
};
